<template>
  <SvoiLoader v-bind="$attrs" />
</template>

<script lang="ts" setup>
  import { SvoiLoader } from '@svoi-ui/components/loader'
</script>
